<template>
  <div>
    <transition name="fade-in" mode="out-in" appear>
      <div key="alert" v-bind:class="`alert alert-${type} ${alertClass}`" role="alert">
        <i v-bind:class="`icon ${iconClass}`" aria-hidden="true" v-show="iconClass"></i>
        <slot>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
module.exports = {
  props: {
    alertClass: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.icon {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// Alert.vue?098d2fea